import React from 'react';
import {
  Database,
  FileText,
  CreditCard,
  Check,
  Wallet,
  Tag,
  Edit3,
  Users,
  Bell,
  User,
  LogOut,
  Menu,
  X,
  Search,
  Download,
  Upload,
  ChevronDown,
  ChevronUp,
  ChevronRight,
  AlertCircle,
  Info,
  CheckCircle,
  XCircle,
  Clock,
  Eye,
  Link,
  QrCode,
  Plus,
  Key,
  Building,
  Phone,
  Star,
  MessageCircle,
  Home,
  Settings,
  TrendingUp,
  Package,
  DollarSign,
  UserPlus,
  Filter,
  RefreshCw,
  ChevronLeft,
  ArrowLeft,
  Store,
  FileSpreadsheet,
  Loader,
  Copy,
  ExternalLink, AlignJustify, Image as ImageIcon
} from 'lucide-react';

const iconMap = {
  db: Database,
  sub: FileText,
  paid: CreditCard,
  ok: Check,
  wallet: Wallet,
  deals: Tag,
  req: Edit3,
  usr: Users,
  bell: Bell,
  prof: User,
  out: LogOut,
  sum: Menu,
  tick: CheckCircle,
  x: XCircle,
  warn: AlertCircle,
  info: Info,
  dl: Download,
  up: Upload,
  cp: Copy,
  qr: QrCode,
  src: Search,
  plus: Plus,
  key: Key,
  bank: Building,
  notify: Phone,
  clock: Clock,
  eye: Eye,
  new: Star,
  wa: MessageCircle,
  home: Home,
  settings: Settings,
  trending: TrendingUp,
  package: Package,
  dollar: DollarSign,
  userPlus: UserPlus,
  filter: Filter,
  refresh: RefreshCw,
  chev: ChevronDown,
  'chevron-down': ChevronDown,
  chevUp: ChevronUp,
  chevRight: ChevronRight,
  'chevron-right': ChevronRight,
  back: ChevronLeft,
  'chevron-left': ChevronLeft,
  arrowLeft: ArrowLeft,
  store: Store,
  file: FileSpreadsheet,
  Loader: Loader,
  ExternalLink: ExternalLink,
  'external-link': ExternalLink,
  alignJustify: AlignJustify,
  image: ImageIcon,
  download: Download,
  copy: Copy,
  check: CheckCircle,
  'message-circle': MessageCircle,
  'refresh-cw': RefreshCw,
  'alert-circle': AlertCircle,
  'alert-triangle': AlertCircle,
  orders: FileText,
  refund: CreditCard,
  product: Package,
};

const Icon = ({ name, size = 16, color = 'currentColor', className = '' }) => {
  const IconComponent = iconMap[name];
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return (
    <IconComponent 
      size={size} 
      color={color} 
      className={className}
      style={{ 
        display: 'inline-flex', 
        alignItems: 'center',
        color: color 
      }}
    />
  );
};

export default Icon;
